import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

export const UPDATE_PAYROLL_SCALE = addAuthVars(gql`
  mutation updatePayrollScale(
    $id: ID!
    $name: String!
    $config: [JSONObject]!
  ) {
    updatePayrollScale(id: $id, name: $name, config: $config) {
      id
      name
      config
    }
  }
`);

export const useUpdatePayrollScale = () => {
  const [update, { loading, error }] = useMutation(UPDATE_PAYROLL_SCALE, {
    onError: error => {
      throw error;
    }
  });
  const updatePayrollScale = async ({
    id,
    name,
    config
  }: {
    id: string;
    name: string;
    config: JSON;
  }) => {
    await update({
      variables: {
        id,
        name,
        config
      },
      refetchQueries: ["payrollScales"]
    });
  };

  return { updatePayrollScale, loading, error };
};
